<template>
  <b-row
    :class="customChange ? 'list-group-item' : ''"
  >
    <b-col
      md="12"
      xl="12"
    >
      <b-overlay
        id="overlay-background"
        :show="installmentloader"
        variant="dark"
        opacity="0.85"
        blur="2px"
        rounded="sm"
        spinner-variant="primary"
        spinner-medium
      >
        <b-card>
          <b-alert
            variant="danger"
            :show="!signature && installmentData.length > 0"
            class="mb-1"
          >
            <div
              v-if="linkSentDate && isWithin24HoursFunction(linkSentDate)"
              class="alert-body"
            >
              <feather-icon

                icon="InfoIcon"
                class="mr-50"
              />
              {{ $t('DEBTOR_HAS_NOT_SIGNED') }} <label class="orange-text">{{ $t('SIGNATURE_SENT_WITHIN_24_HOURS') }}</label>.
            </div>
            <div
              v-else
              class="alert-body"
            >
              <feather-icon

                icon="InfoIcon"
                class="mr-50"
              />
              {{ $t('DEBTOR_HAS_NOT_SIGNED_PLEASE') }} <b-link @click="sendLink">
                {{ $t('CLICK_HERE') }}
              </b-link> {{ $t('SIGNATURE_LINK') }}
            </div>
          </b-alert>
          <b-card-header
            class="installment-plan-header"
          >
            <b-card-title>{{ $t('DEBTIA_INSTALLMENT_PLAN') }}</b-card-title>
          </b-card-header>
          <b-card-body
            class="installment-plan-body"
          >
            <b-overlay
              id="overlay-background"
              :show="planLoader"
              variant="dark"
              opacity="0.85"
              blur="2px"
              rounded="sm"
              spinner-variant="primary"
              spinner-medium
            >
              <div
                v-if="installmentData.length > 0"
                class="scroll-div-installment"
              >
                <b-table
                  :fields="installmentTableFields"
                  :items="installmentData"
                  striped
                >
                  <template #cell(amount)="row">
                    {{ `${formatCurrency(row.item.installment_amount, defaultCurrency)}` }}
                  </template>
                  <template #cell(interest)="row">
                    {{ `${formatCurrency(row.item.interest, defaultCurrency)}` }}
                  </template>
                  <template #cell(remaining_amount)="row">
                    {{ `${formatCurrency(row.item.remaining_amount, defaultCurrency)}` }}
                  </template>
                  <template #cell(status)="row">
                    <b-badge
                      v-if="row.item.is_paid"
                      variant="success"
                      class="badge-glow"
                    >
                      {{ $t('DEBTIA_PAID') + ' (' + row.item.payment_date + ')' }}
                    </b-badge>
                    <b-badge
                      v-else-if="!row.item.is_paid && row.item.failed_reasons !== null"
                      variant="danger"
                      class="badge-glow"
                    >
                      {{ row.item.failed_reasons }}
                    </b-badge>
                    <b-badge
                      v-else
                      variant="warning"
                      class="badge-glow"
                    >
                      {{ $t('DEBTIA_NOT_PAID') }}
                    </b-badge>
                  </template>
                </b-table>
              </div>
              <b-alert
                v-else
                variant="warning"
                show
              >
                <div class="alert-body">
                  {{ $t('DEBTIA_NO_PLAN_GENERATED_MSG') }}
                </div>
              </b-alert>
            </b-overlay>
          </b-card-body>
        </b-card>
      </b-overlay>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow, BCol, BCard, BCardHeader, BCardTitle, BAlert, BTable, BCardBody, BOverlay, BLink,
  BBadge,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import constants from '@/app-configs/constants'
import i18n from '@/libs/i18n'
import { EventBus } from '@/event-bus'
import axios from '@axios'

export default {
  inject: ['sharedState'],
  components: {
    BRow,
    BCol,
    BCard,
    BAlert,
    BTable,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BOverlay,
    BLink,
    BBadge,
  },
  directives: {
    Ripple,
  },
  props: {
    side: {
      type: String,
      required: true,
    },
    customChange: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      constants,
      installmentloader: false,
      installmentData: [],
      installmentplanstatus: 404,
      userType: JSON.parse(localStorage.getItem('userData')).data.user_type,
      isSuperAdmin: false,
      caseId: this.$route.params.id,
      defaultCurrency: 'DKK',
      signature: false,
      linkSentDate: null,
      isWithin24Hours: false,
      generate_signature_link_email_template_id: 0,
      planLoader: false,
      hasFetchedInstallments: false,
      journal_id: '',
    }
  },
  computed: {
    installmentTableFields() {
      return [
        { key: 'installment_date', label: i18n.t('DEBTIA_INSTALLMENT_DATE') },
        { key: 'interest', label: i18n.t('DEBTIA_INSTALLMENT_INTEREST') },
        { key: 'amount', label: i18n.t('DEBTIA_AMOUNT') },
        { key: 'remaining_amount', label: i18n.t('DEBTIA_REMAINING_AMOUNT') },
        { key: 'status', label: i18n.t('DEBTIA_STATUS') },
      ]
    },
  },
  watch: {
    'sharedState.paymentSettings': {
      handler() {
        this.getInstallmentPlans()
      },
      deep: true,
    },
    'sharedState.clientsData': {
      handler(newVal) {
        this.journal_id = newVal.bc_case_id
      },
    },
  },
  methods: {
    isWithin24HoursFunction(date) {
      const currentDate = new Date()
      const targetDate = new Date(date.replace(' ', 'T'))

      const diffInMs = currentDate - targetDate

      const diffInHours = diffInMs / (1000 * 60 * 60)

      return diffInHours <= 24 && diffInHours >= 0
    },
    async sendLink() {
      await axios.post(`${constants.paymentsBaseUrl}/installment_plan/generate_signature_link`, {
        journal_id: this.journal_id,
      }).then(response => {
        if (response.status) {
          const tokenUrl = response.data.tokenized_url
          window.open(tokenUrl, '_blank')
        }
      }).catch(error => {
        console.log(error)
      })
    },
    formatCurrency(amount, defaultCurrency) {
      return new Intl.NumberFormat('da-DK', { style: 'currency', currency: defaultCurrency }).format(parseFloat(amount).toFixed(2))
    },
    getIsSuperAdmin() {
      if (this.userType === 'super-admin') {
        this.isSuperAdmin = true
      } else {
        this.isSuperAdmin = false
      }
    },
    getInstallmentPlans() {
      this.installmentloader = true
      const headers = {
        clientId: constants.debtiaappClientID,
        secret: constants.debtiaappSecret,
      }
      axios.get(`${constants.paymentsBaseUrl}/installment_plan/get_installments?journal_id=${this.caseId}`, {
        headers,
      }).then(response => {
        if (response.status) {
          this.installmentloader = false
          this.signature = response.data.data.signature
          this.linkSentDate = response.data.data.plan_signature_link_at
          this.installmentData = response.data.data.installments_data
          this.installmentplanstatus = response.data.data.plan_status
          EventBus.$emit('getInstallmentPlanData', this.installmentData)
        }
      }).catch(error => {
        if (error.response && error.response.data && error.response.data.data) {
          const fullstatus = error.response.data.data.full_payment_status
          EventBus.$emit('fullPaymentStatus', fullstatus)
        }
        this.installmentData = []
        EventBus.$emit('getInstallmentPlanData', this.installmentData)
        this.installmentplanstatus = 404
        this.installmentloader = false
      })
    },
  },
}
</script>

  <style lang="scss">
  .scroll-div-installment {
    overflow-y: scroll;
    /* Ensure the inner div doesn't exceed the container */
    max-height: 400px;
    padding-right: 10px;
  }

  .scroll-div-installment::-webkit-scrollbar {
      width: 12px;
  }

  .scroll-div-installment::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
      border-radius: 10px;
  }

  .scroll-div-installment::-webkit-scrollbar-thumb {
      border-radius: 10px;
      -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5);
  }
  .orange-text {
    color: orange;
  }

  </style>
